import styled from 'styled-components'
import Facebook from '../../static/images/facebook.svg'
import Twitter from '../../static/images/twitter.svg'
import { breakpoints } from '../../constants/theme'

const FooterContainer = styled.footer`
  background: ${(props) =>
    props.theme.colors.background.backgroundColorDarkest};
  color: ${(props) => props.theme.colors.fonts.grey};
  padding: 40px 20px;

  li,
  p {
    margin: 0;

    a {
      color: ${(props) => props.theme.colors.body.light};
    }
  }

  #facebook {
    text-indent: -10000px;
    background: url(${Facebook}) center center no-repeat;
    background-size: contain;
    height: 25px;
    width: 25px;
    display: block;
  }

  #twitter {
    text-indent: -10000px;
    background: url(${Twitter}) center center no-repeat;
    background-size: contain;
    height: 25px;
    width: 25px;
    display: block;
  }
`

const FooterInner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  max-width: ${(props) => props.theme.sizes.siteBaseWidth};
  margin: 0 auto;

  @media ${breakpoints.tablet} {
    margin: 0;
    width: 100%;
    flex-direction: column;
  }
`
const FooterSocial = styled.div`
  max-width: ${(props) => props.theme.sizes.siteBaseWidth};
  margin: 1.25rem auto 0.5rem auto;
  display: flex;
  flex-direction: row;

  > * {
    line-height: 30px;
    margin-right: 7.5px;
  }
`

const FooterTerms = styled.div`
  max-width: ${(props) => props.theme.sizes.siteBaseWidth};
  margin: 0.5rem auto;
  display: grid;
  grid-template-columns: auto;
  grid-row-gap: 0.5rem;
`

const FooterColumn = styled.ul`
  list-style: none;
  margin: 0 20px 20px 0;
  padding: 0;
  -webkit-flex-basis: 22%;
  flex-basis: 22%;
`

const FooterItem = styled.li`
  list-style: none;
  padding: 0.2em 0;
  white-space: nowrap;
  display: block;
  line-height: 26px;

  a {
    text-decoration: none;
    font-size: 18px;
    font-weight: 300;
    color: ${(props) => props.theme.colors.body.light};
  }

  button#ot-sdk-btn.cookie-pref-btn {
    padding: 0;
    border: none;
    font-weight: 300;
    font-size: 18px;
    line-height: 26px;
    white-space: nowrap;
    background-color: transparent;
    color: ${(props) => props.theme.colors.fonts.fontColor};
  }
`

const PdfNotation = styled.span`
  font-size: 80%;
  color: ${(props) => props.theme.colors.fonts.grey};
`

const ActivateSimButton = styled.div`
  display: flex;
  flex-basis: 22%;
  justify-content: start;

  a {
    height: 25px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 12px;
    padding: 6px 15px;
    border-radius: 4px;
    font-weight: 700;
    text-decoration: none;
    background-color: ${(props) =>
      props.theme.colors.background.backgroundColor};
    color: ${(props) => props.theme.colors.fonts.fontColor};
  }

  @media ${breakpoints.tablet} {
    justify-content: flex-start;

    a {
      font-size: 14px;
    }
  }
`
const GooglePlayStoreImage = styled.img`
  max-width: 10.125rem;
`

const IosAppImage = styled.img`
  max-width: 8.823rem;
  margin: 2rem 0 1rem;
`
export {
  FooterContainer,
  FooterInner,
  FooterColumn,
  FooterItem,
  FooterSocial,
  FooterTerms,
  PdfNotation,
  ActivateSimButton,
  GooglePlayStoreImage,
  IosAppImage,
}
